import { Vue } from "vue-property-decorator";

const Rules = {
  Required: (v: any, or: boolean) => or || !!v || "必須項目です。",
  TimeRequired: (v: any) =>
    (v != "00:00" && v != "00:00:00") || "時間が必要です。",
  DuplicateCheck: (v: any, or: boolean) =>
    or || !!v || "確認事項は２項目以上チェックが必要です"
};

export default Vue.extend({
  name: "Forms",
  components: {},
  data() {
    return {
      valid: false,
      Rules
    };
  },
  computed: {},
  methods: {}
});
